module.exports = __webpack_public_path__ + "static/img/icon.e1f0f1a6.png";